
const MESSAGES = {
    'it': {
        'counter.hai': 'Hai',
        'counter.preferiti': 'preferiti',
        'share.button.text': 'condividi la tua lista dei preferiti',
        'share.modal.copy': 'Copia link',
        'share.modal.usa': 'Usa questo URL per condividere la tua lista dei preferiti',
        'richiedi.header.prompt.appuntamento.help': 'Consulta i documenti nella nostra sede',
        'button.reset': 'Azzera i preferiti',
    },
    'en': {
        'counter.hai': 'You have',
        'counter.preferiti': 'bookmarks',
        'share.button.text': 'Share your favourites list',
        'share.modal.copy': 'Copy link',
        'share.modal.usa': 'Use this URL to share your favourites list',
        'richiedi.header.prompt.appuntamento.help': 'See the documentation at our headquarters',
        'button.reset': 'Empty the bookmarks list',
    }
};

export default function message(name) {
    return MESSAGES[window.BOOKMARK_CONF.lang][name] || '';
}
